import { render } from "./product-amount.vue?vue&type=template&id=44daa63e"
import script from "./product-amount.vue?vue&type=script&lang=js"
export * from "./product-amount.vue?vue&type=script&lang=js"

import "./product-amount.vue?vue&type=style&index=0&id=44daa63e&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__